import { useEffect, useRef } from "react";
import { useReactFlow } from "@xyflow/react";

const INITIAL_VIEWPORT_OPTIONS = {
    padding: 0.25,
    maxZoom: 0.85,
    duration: 0,
};

/** Centers and zooms the canvas once per workflow load after nodes are hydrated. */
export function WorkflowCanvasViewport({ ready, nodeCount, canvasKey }) {
    const { fitView } = useReactFlow();
    const fittedKeyRef = useRef(null);

    useEffect(() => {
        if (!ready || nodeCount === 0) return;
        if (fittedKeyRef.current === canvasKey) return;

        let cancelled = false;
        const frame = requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                if (cancelled) return;
                fitView(INITIAL_VIEWPORT_OPTIONS);
                fittedKeyRef.current = canvasKey;
            });
        });

        return () => {
            cancelled = true;
            cancelAnimationFrame(frame);
        };
    }, [ready, nodeCount, canvasKey, fitView]);

    return null;
}
